import type { EditorPerformanceResult } from '@carboncopyco/types';

export const sumPerformanceResults = (
  result1: EditorPerformanceResult,
  result2: EditorPerformanceResult
): EditorPerformanceResult => {
  const sumObjects = (obj1: any, obj2: any): any => {
    const result: any = {};
    for (const key in obj1) {
      if (typeof obj1[key] === 'number' && typeof obj2[key] === 'number') {
        result[key] = obj1[key] + obj2[key]; // Add numbers
      } else if (
        typeof obj1[key] === 'object' &&
        typeof obj2[key] === 'object'
      ) {
        result[key] = sumObjects(obj1[key], obj2[key]); // Recursively sum objects
      }
    }

    return result;
  };

  try {
    const result = sumObjects(result1, result2);

    return result;
  } catch (e) {
    console.error(e);
  }
};
